module.exports = __webpack_public_path__ + "images/8c8546d124f8e481935fe622cbe632de-illu_newBox_PanelBox.png";